import React from 'react';
import { Link } from 'react-router-dom';
import spottoLogo from '../assets/spotto-logo.png';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface-app">
      {/* Header */}
      <header className="bg-surface-card border-b border-border-subtle">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src={spottoLogo} 
                alt="Spotto Logo" 
                className="h-10 w-auto"
              />
              <h1 className="text-xl font-bold text-white">Spotto</h1>
            </div>
            <Link 
              to="/login" 
              className="text-brand-primary hover:text-brand-primary transition-colors text-sm font-medium"
            >
              Powrót do logowania
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-surface-card rounded-2xl border border-border-subtle p-8 lg:p-12 shadow-xl">
          {/* Title */}
          <div className="text-center mb-12">
            <h1 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              POLITYKA PRZETWARZANIA DANYCH OSOBOWYCH (RODO)
            </h1>
            <div className="w-24 h-1 bg-brand-primary/50 mx-auto"></div>
          </div>

          {/* Content */}
          <div className="prose prose-invert max-w-none space-y-8">
            
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">1</span>
                Administrator danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary leading-relaxed">
                  Administratorem danych osobowych jest <strong className="text-white">SOLID LABS PSA</strong>, 
                  Mogilska 43, Kraków 31-545, <a href="mailto:support@spotto.pl" className="text-brand-primary hover:text-brand-primary transition-colors">support@spotto.pl</a>, 
                  NIP: 7517689864, dalej zwany „Administratorem".
                </p>
              </div>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">2</span>
                Zakres przetwarzanych danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary mb-4">Administrator przetwarza następujące dane osobowe:</p>
                <ul className="space-y-2 text-ink-primary">
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    imię i nazwisko,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    adres e-mail,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    numer telefonu,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    NIP (jeśli dotyczy),
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    dane dotyczące dokonanych rezerwacji, płatności i historii korzystania z Platformy.
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">3</span>
                Cele i podstawa prawna przetwarzania
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary mb-4">Dane osobowe przetwarzane są w celu:</p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <span className="bg-brand-primary/50 text-white rounded w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-1 shrink-0">1</span>
                    <span className="text-ink-primary">umożliwienia rejestracji konta i korzystania z Platformy (art. 6 ust. 1 lit. b RODO),</span>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-brand-primary/50 text-white rounded w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-1 shrink-0">2</span>
                    <span className="text-ink-primary">realizacji rezerwacji usług sportowych (art. 6 ust. 1 lit. b RODO),</span>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-brand-primary/50 text-white rounded w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-1 shrink-0">3</span>
                    <span className="text-ink-primary">obsługi reklamacji i kontaktu z Użytkownikiem (art. 6 ust. 1 lit. c i f RODO),</span>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-brand-primary/50 text-white rounded w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-1 shrink-0">4</span>
                    <span className="text-ink-primary">marketingu bezpośredniego (na podstawie zgody, art. 6 ust. 1 lit. a RODO),</span>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-brand-primary/50 text-white rounded w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-1 shrink-0">5</span>
                    <span className="text-ink-primary">realizacji obowiązków księgowych i podatkowych (art. 6 ust. 1 lit. c RODO).</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">4</span>
                Przekazywanie danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary mb-4">Dane mogą być przekazywane:</p>
                <ul className="space-y-2 text-ink-primary">
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    Obiektom i Trenerom, u których dokonywana jest rezerwacja,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    operatorom płatności,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    dostawcom usług IT i hostingu,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    uprawnionym organom publicznym na podstawie przepisów prawa.
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">5</span>
                Okres przechowywania danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary mb-4">Dane osobowe są przechowywane:</p>
                <ul className="space-y-2 text-ink-primary">
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    przez okres niezbędny do realizacji rezerwacji i obsługi konta,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    przez okres wymagany przepisami prawa (np. podatkowego – 5 lat),
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    dane przetwarzane na podstawie zgody – do momentu jej wycofania.
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">6</span>
                Prawa użytkownika
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary mb-4">Użytkownik ma prawo do:</p>
                <ul className="space-y-2 text-ink-primary">
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    dostępu do danych,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    sprostowania, usunięcia lub ograniczenia przetwarzania,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    przenoszenia danych,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    sprzeciwu wobec przetwarzania,
                  </li>
                  <li className="flex items-start">
                    <span className="text-brand-primary mr-3 mt-1">•</span>
                    cofnięcia zgody w dowolnym momencie.
                  </li>
                </ul>
                <p className="text-ink-primary mt-4">
                  Żądania można kierować na adres e-mail: 
                  <a href="mailto:support@spotto.pl" className="text-brand-primary hover:text-brand-primary transition-colors ml-1">
                    support@spotto.pl
                  </a>
                </p>
              </div>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">7</span>
                Bezpieczeństwo danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary">
                  Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę danych osobowych 
                  przed nieuprawnionym dostępem, utratą lub modyfikacją.
                </p>
              </div>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">8</span>
                Inspektor Ochrony Danych
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary">
                  Jeśli Administrator powołał Inspektora Ochrony Danych, jego dane kontaktowe zostaną podane na stronie Serwisu.
                </p>
              </div>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">9</span>
                Pliki cookies
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary">
                  Serwis wykorzystuje pliki cookies w celach statystycznych, funkcjonalnych i marketingowych. 
                  Użytkownik może w każdej chwili zmienić ustawienia przeglądarki w zakresie cookies.
                </p>
              </div>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="bg-brand-primary/50 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4">10</span>
                Zmiany polityki prywatności
              </h2>
              <div className="bg-surface-app-elevated rounded-lg p-6 border border-border-strong">
                <p className="text-ink-primary">
                  Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej polityce. 
                  Aktualna wersja dokumentu dostępna jest na stronie internetowej Serwisu.
                </p>
              </div>
            </section>

          </div>

          {/* Footer with last updated */}
          <div className="mt-12 pt-8 border-t border-border-strong text-center">
            <p className="text-ink-muted text-sm">
              Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
            </p>
          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-surface-card border-t border-border-subtle mt-12">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="text-center">
            <p className="text-ink-muted text-sm">
              © {new Date().getFullYear()} SOLID LABS PSA. Wszystkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};